<template>
	<form
		class="Form"
		:style="{
			'--color': config.color || 'var(--clrTheme)',
			'--backgroundColor': config.backgroundColor || '#F4F4F4',
			'--textColor': config.textColor || '#666',
			'--titleColor': config.titleColor || '#444'
		}"
		v-bind="$attrs"
	>
		<element
			v-for="entry in form"
			:key="entry.name"
			:is="getElement(entry.type)"
			v-bind="entry"
			:value="cache[entry.name]"
			@change="onChange(entry.name, $event)"
			:formId="formId"
		></element>
	</form>
</template>

<script>
	import FormInput from './form/FormInput';
	import FormDateTime from './form/FormDateTime';
	import FormImage from './form/FormImage';
	import FormDropdown from './form/FormDropdown';
	import FormCheckbox from './form/FormCheckbox';
	import FormToggle from './form/FormToggle';
	import FormColor from './form/FormColor';
	import FormCalendar from './form/FormCalendar';

	export default {
		props: {
			data: {},
			form: {},
			config: {
				default: () => ({})
			}
		},
		data() {
			return {
				cache: {}
			};
		},
		components: {
			FormInput,
			FormImage,
			FormDropdown,
			FormCheckbox,
			FormToggle,
			FormColor,
			FormCalendar
		},

		methods: {
			getElement(type) {
				return (
					{
						text: FormInput,
						image: FormImage,
						dropdown: FormDropdown,
						date: FormDateTime,
						time: FormDateTime,
						datetime: FormDateTime,
						checkbox: FormCheckbox,
						radio: FormCheckbox,
						toggle: FormToggle,
						color: FormColor,
						calendar: FormCalendar
					}[type] || FormInput
				);
			},

			onChange(name, value) {
				this.cache = { ...this.cache, [name]: value };
				this.$emit('change', name, value);
			}
		},
		watch: {
			data() {
				this.cache = this.parseJSON(JSON.stringify(this.data));
			}
		},
		computed: {
			formId() {
				return Math.random()
					.toString()
					.replace('0.', '');
			}
		},

		beforeMount() {
			this.cache = this.parseJSON(JSON.stringify(this.data));
		}
	};
</script>

<style scoped lang="scss">
	.Form {
		--color: var(var(--override), var(--colorTheme));
		color: var(--textColor);

		/deep/ .form-group {
			display: flex;
			flex-direction: column;

			&:not(:first-of-type) {
				margin-top: 2rem;
			}

			.title {
				margin-bottom: 0.5rem;
				color: var(--titleColor);

				&.required {
					&::before {
						content: '*';
						color: #7f171f;
						margin-right: 0.25em;
					}

					&::after {
						margin-left: 0.33em;
						content: '(required)';
						font-size: 0.8em;
						opacity: 0.5;
					}
				}
			}

			.input-area {
				position: relative;
				flex: 1;

				&:not(:first-of-type) {
					margin-top: 1rem;
				}

				i {
					color: var(--color);
					display: block;
					position: absolute;
					width: 2rem;
					display: flex;
					align-items: center;
					justify-content: center;
					top: 50%;
					left: 1.6rem;
					transform: translateY(-50%);
					font-size: 1.33em;
				}

				i + * {
					padding-left: 4.6rem;
				}

				*:not(i) {
					width: 100%;
					color: var(--textColor);
					&::placeholder {
						opacity: 0.3;
					}
				}
			}
		}
	}
</style>
